import React from 'react'
import { Button, Header, Image, Modal } from 'semantic-ui-react'
import {i18n} from "../i18n";
import { serviceBaseUrl } from '../config.js'


function modalReducer(state, action) {
    switch (action.type) {
        case 'OPEN_MODAL':
            return { open: true, dimmer: action.dimmer }
        case 'CLOSE_MODAL':
            return { open: false }
        default:
            throw new Error()
    }
}

function JobAboModal() {
    const [state, dispatch] = React.useReducer(modalReducer, {
        open: false,
        dimmer: undefined,
    })
    const { open, dimmer } = state

    return (
        <div>
            <button className="tag__button jobAbo"
                onClick={() => dispatch({ type: 'OPEN_MODAL', dimmer: 'inverted' })}
            >
                <span className="tag__label">{i18n.translations.jobAbo}</span>
            </button>

            <Modal closeIcon
                dimmer={dimmer}
                open={open}
                onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
                >
                <Modal.Content>
                    <Header>Job-Newsletter</Header>

                    <div className="container">
                        <iframe className="responsive-iframe" src={`${serviceBaseUrl}/careercenter/1001134/jobabo?lang=${i18n.lang}`}/>
                    </div>
                </Modal.Content>

            </Modal>
        </div>
    )
}

export default JobAboModal
